import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SOURCE_TYPE_LABELS,
  SOURCE_TYPE_META,
  SOURCE_TYPES,
  type SourceType
} from '@/components/sources/sourceTypeMeta';

export type SourceTypeFilter = 'all' | SourceType;

export type SourceTypeCounts = Record<SourceType, number>;

interface SourcesTypeFilterProps {
  currentFilter: SourceTypeFilter;
  onFilterChange: (filter: SourceTypeFilter) => void;
  countsByType: SourceTypeCounts;
  totalCount: number;
}

const SourcesTypeFilter: React.FC<SourcesTypeFilterProps> = ({
  currentFilter,
  onFilterChange,
  countsByType,
  totalCount
}) => {
  const { t } = useTranslation('forms');

  return (
    <div className="list-seg" role="tablist" aria-label={t('sources.filterByType')}>
      <button
        type="button"
        role="tab"
        aria-selected={currentFilter === 'all'}
        className={`list-seg__btn${currentFilter === 'all' ? ' list-seg__btn--active' : ''}`}
        onClick={() => onFilterChange('all')}
      >
        {t('sources.all')}
        <span className="list-seg__count">{totalCount}</span>
      </button>
      {SOURCE_TYPES.map((type) => {
        const { Icon } = SOURCE_TYPE_META[type];
        return (
          <button
            key={type}
            type="button"
            role="tab"
            aria-selected={currentFilter === type}
            className={`list-seg__btn${currentFilter === type ? ' list-seg__btn--active' : ''}`}
            onClick={() => onFilterChange(type)}
          >
            <Icon width={14} height={14} />
            {SOURCE_TYPE_LABELS[type]}
            <span className="list-seg__count">{countsByType[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SourcesTypeFilter;
